import { asChildPropDef } from '../props/as-child.prop';
import { AccentColor, GrayColor, accentColors, grayColors } from '../props/color.prop';
import type { GetPropDefTypes, PropDef } from '../props/prop-def';
import { Radius, radii } from '../props/radius.prop';

const appearances = ['inherit', 'light', 'dark'] as const;
const panelBackgrounds = ['solid', 'translucent'] as const;
const scalings = ['90%', '95%', '100%', '105%', '110%'] as const;

type Appearance = (typeof appearances)[number];
type PanelBackground = (typeof panelBackgrounds)[number];
type Scaling = (typeof scalings)[number];

const themePropDefs = {
  ...asChildPropDef,
  hasBackground: { type: 'boolean', default: true },
  appearance: { type: 'enum', values: appearances, default: 'light' },
  accentColor: { type: 'enum', values: accentColors, default: 'blue' },
  grayColor: { type: 'enum', values: grayColors, default: 'gray' },
  panelBackground: { type: 'enum', values: panelBackgrounds, default: 'solid' },
  radius: { type: 'enum', values: radii, default: 'medium' },
  scaling: { type: 'enum', values: scalings, default: '100%' }
} satisfies {
  hasBackground: PropDef<boolean>;
  appearance: PropDef<Appearance>;
  accentColor: PropDef<AccentColor>;
  grayColor: PropDef<GrayColor>;
  panelBackground: PropDef<PanelBackground>;
  radius: PropDef<Radius>;
  scaling: PropDef<Scaling>;
};

type ThemeOwnProps = GetPropDefTypes<typeof themePropDefs & typeof asChildPropDef>;

export { themePropDefs };
export type { ThemeOwnProps };
